import { useContext } from 'react';
import { AccordionItemContext } from './AccordionItem';

export const useAccordionItem = () => {
    const accordionItemContext = useContext(AccordionItemContext);
    return accordionItemContext;
};
